import { create } from "zustand";
import { persist } from "zustand/middleware";

export const CONFIRM_PREF_KEYS = {
  startAttending: "start-attending",
  externalLink: "external-link",
} as const;

export type ConfirmPrefKey =
  (typeof CONFIRM_PREF_KEYS)[keyof typeof CONFIRM_PREF_KEYS];

type ConfirmPreferencesState = {
  skipped: Record<ConfirmPrefKey, boolean>;
  isSkipped: (key: ConfirmPrefKey) => boolean;
  setSkipped: (key: ConfirmPrefKey, value: boolean) => void;
};

export const useConfirmPreferences = create<ConfirmPreferencesState>()(
  persist(
    (set, get) => ({
      skipped: {} as Record<ConfirmPrefKey, boolean>,
      isSkipped: (key) => Boolean(get().skipped[key]),
      setSkipped: (key, value) =>
        set((state) => ({
          skipped: { ...state.skipped, [key]: value },
        })),
    }),
    {
      name: "super-agents-confirm-prefs",
      partialize: (state) => ({ skipped: state.skipped }),
    }
  )
);
